webpackJsonp([51],{

/***/ 1085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(807);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf0bb1c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(1088);
function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf0bb1c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf0bb1c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1087);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("53e8069a", content, true, {});

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".active[data-v-cf0bb1c8]{background:#ddd}.popular-currencies[data-v-cf0bb1c8]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:5px}.popular-currencies span[data-v-cf0bb1c8]{font-style:italic;color:#757575}", "", {"version":3,"sources":["/app/src/components/shared/Header.vue"],"names":[],"mappings":"AACA,yBACE,eAAiB,CAClB,AACD,qCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,OAAS,CACV,AACD,0CACE,kBAAmB,AACnB,aAAe,CAChB","file":"Header.vue","sourcesContent":["\n.active[data-v-cf0bb1c8] {\n  background: #ddd;\n}\n.popular-currencies[data-v-cf0bb1c8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 5px;\n}\n.popular-currencies span[data-v-cf0bb1c8] {\n  font-style: italic;\n  color: #757575;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('nav',{staticClass:"navbar navbar-fixed-top",attrs:{"role":"navigation"}},[_c('div',{},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand client-logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.smallLogo}})])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMainMenuDisplayed && !_vm.isReservationStepDisplayed),expression:"isMainMenuDisplayed && !isReservationStepDisplayed"}],staticClass:"main-menu"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMainMenuDisplayed && _vm.isReservationStepDisplayed),expression:"!isMainMenuDisplayed && isReservationStepDisplayed"}],staticClass:"other-menu navbar-step"},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"navbar-collapse collapse navbar-data pull-right",attrs:{"role":"navigation"}},[_c('ul',{staticClass:"nav navbar-nav right-menu pull-right"},[_c('li',{staticClass:"hidden"},[_c('router-link',{attrs:{"to":"/*","id":"manageBooking"}},[_c('i',{staticClass:"ic-search",class:{ isActive: !_vm.isMainMenuDisplayed }})])],1),_vm._v(" "),_c('li',{staticClass:"hidden"},[_c('a',[_c('i',{staticClass:"ic-booking-history",class:{ isActive: _vm.isMainMenuDisplayed }})])]),_vm._v(" "),_c('li',{staticClass:"hidden"},[_c('a',[_c('i',{staticClass:"ic-transaction",class:{ isActive: _vm.isMainMenuDisplayed }})])]),_vm._v(" "),_c('li',{staticClass:"hidden"},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-allMenu"},[_c('div',{staticClass:"newCaret"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":_vm.cdn + '/images/icon/data-master.svg'}}),_vm._v("\n                    Invoice\n                  ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":_vm.cdn + '/images/icon/transactional-report.svg'}}),_vm._v("\n                    Transactional Report\n                  ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":_vm.cdn + '/images/icon/setting-hor.svg'}}),_vm._v("\n                    Imports Form CSV\n                  ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":_vm.cdn + '/images/icon/setting-hor.svg'}}),_vm._v("\n                    Imports Group\n                  ")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":_vm.cdn + '/images/icon/wallet.svg'}}),_vm._v("\n                    Customer Deposit\n                  ")])])])]),_vm._v(" "),_c('li',{staticClass:"hidden"},[_vm._m(3),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-cartMenu"},[_c('div',{staticClass:"newCaret"}),_vm._v(" "),_c('div',{staticClass:"emptyList"},[_c('img',{attrs:{"src":_vm.cdn + '/images/icon/No-List.svg'}}),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("No Notification")])])])]),_vm._v(" "),_c('li',{staticClass:"profile"},[_c('a',{attrs:{"href":"javascript:void(0)","type":"button","data-toggle":"dropdown"}},[_c('span',[_vm._v(_vm._s(_vm.profileInitial))])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-profileMenu",attrs:{"role":"menu","aria-labelledby":"menu1"}},[_c('div',{staticClass:"newCaret"}),_vm._v(" "),_c('li',{staticClass:"head__info-welcome"},[_vm._v("\n                  Hi, "+_vm._s(_vm.profileName)+" "),_c('span',[_vm._v(_vm._s(_vm.profileUsername))])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),(_vm.productUrl && _vm.productTitle)?_c('li',{staticClass:"gotoProduct"},[_c('a',{attrs:{"href":_vm.productUrl,"target":"_blank"}},[_c('span',{staticClass:"logo-goto"},[_c('img',{attrs:{"src":_vm.opsigoLogo}})]),_vm._v("\n                    Go to "+_vm._s(_vm.productTitle)+" "),_c('span',[_vm._v("Learn more")])])]):_vm._e(),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/profile","id":"user-link"}},[_vm._v("Profile Settings")])],1),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"logout",attrs:{"to":"/logout"}},[_vm._v("Log Out")])],1)])])])]),_vm._v(" "),(!_vm.transactionCurrency)?_c('div',{staticClass:"navbar-collapse collapse navbar-data pull-right",attrs:{"role":"navigation"}},[_c('ul',{staticClass:"nav navbar-nav right-menu pull-right"},[_c('li',{staticClass:"profile multi-currency"},[_c('a',{attrs:{"href":"javascript:void(0)","type":"button","data-toggle":"dropdown"}},[_c('span',[_vm._v(_vm._s(_vm.getSelectedCurrency)+"\n                  "),_c('div',{staticClass:"arrow-dropdown"})])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-currency",attrs:{"role":"menu","aria-labelledby":"menu1"}},[_c('div',{staticClass:"newCaret"}),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"wrapper-item-currency mt-10"},[_vm._l((_vm.currencies),function(currency,index){return [_c('div',{key:index,class:_vm.getSelectedCurrency === currency.value
                          ? 'item-currency active'
                          : 'item-currency',on:{"click":function($event){return _vm.setCurrency(currency.value)}}},[_vm._v("\n                      "+_vm._s(currency.value)+" "),_c('span',[_vm._v(_vm._s(currency.text))])])]})],2)])])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle"},[_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"step-number"},[_vm._v("1")]),_vm._v("\n                  Select Car\n                ")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"step-number"},[_vm._v("2")]),_vm._v("\n                  Reservation Info\n                ")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_c('span',{staticClass:"step-number"},[_vm._v("3")]),_vm._v("\n                Confirmation\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)","type":"button","data-toggle":"dropdown"}},[_c('i',{staticClass:"ic-all-menu"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0)","type":"button","data-toggle":"dropdown"}},[_c('i',{staticClass:"ic-notification"},[_c('span',{staticClass:"sts-listOrder"},[_c('div',{staticClass:"pulse"}),_vm._v(" "),_c('div',{staticClass:"pulse"}),_vm._v(" "),_c('div',{staticClass:"pulse"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"hidden"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"ic-transactional-report"}),_vm._v(" Your Performance\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://support.trransfer.com/","target":"_blank","id":"user-link"}},[_vm._v("User Guide")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.trransfer.com/privacypolicy","target":"_blank","id":"user-link"}},[_vm._v("Privacy Policy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popular-currencies"},[_vm._v("\n                  Supported currencies "),_c('span',[_vm._v("(for Credit Card payments)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(808);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365fe750_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(1090);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_365fe750_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1090:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pos-rel"},[_c('div',{staticClass:"left-menu"},[_c('div',[_c('div',{staticClass:"header__left-menu"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.productImage}})])],1),_vm._v(" "),_c('ul',{staticClass:"left-menu--list"},[(_vm.isProviderCandidateVisible)?_c('li',{staticClass:"nav-parent",attrs:{"id":"onboarding"}},[_c('router-link',{attrs:{"to":"/onboarding","id":"provider-candidate-link"}},[_c('i',{staticClass:"ic-businessmen"}),_vm._v(" On-Boarding\n          ")])],1):_vm._e(),_vm._v(" "),(
            _vm.isTenantReportVisible ||
            _vm.isProviderReportVisible ||
            _vm.isCustomerReportVisible
          )?_c('li',{staticClass:"nav-parent",attrs:{"id":"booking-history"}},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nav-master",attrs:{"role":"menu"}},[(_vm.isTenantReportVisible)?_c('li',[_c('router-link',{attrs:{"to":"/report/tenant","id":"tenant-report-link"}},[_vm._v("\n                Tenant Transactions\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isProviderReportVisible)?_c('li',[_c('router-link',{attrs:{"to":"/report/provider","id":"provider-report-link"}},[_vm._v("\n                Provider Transactions\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isCustomerReportVisible)?_c('li',[_c('router-link',{attrs:{"to":"/report/customer","id":"customer-report-link"}},[_vm._v("\n                Customer Transactions\n              ")])],1):_vm._e()])]):_vm._e(),_vm._v(" "),(
            _vm.isAvailableJobVisible ||
            _vm.isTenantJobVisible ||
            _vm.isProviderJobVisible ||
            _vm.isDriverJobVisible
          )?_c('li',{staticClass:"nav-parent",attrs:{"id":"job"}},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nav-master",attrs:{"role":"menu"}},[(_vm.isAvailableJobVisible)?_c('li',[_c('router-link',{attrs:{"to":"/job/available","id":"available-job-browser-link"}},[_vm._v("\n                Open Jobs\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isTenantJobVisible)?_c('li',[_c('router-link',{attrs:{"to":"/job/tenant","id":"tenant-job-browser-link"}},[_vm._v("\n                Tenant Jobs\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isProviderJobVisible)?_c('li',[_c('router-link',{attrs:{"to":"/job/provider","id":"provider-job-browser-link"}},[_vm._v("\n                Provider Assigned\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isDriverJobVisible)?_c('li',[_c('router-link',{attrs:{"to":"/job/driver","id":"driver-job-browser-link"}},[_vm._v("\n                Driver Assigned\n              ")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/fleet/driver-tracker","id":"fleet-driver-tracker-link"}},[_vm._v("\n                Fleet Tracker\n              ")])],1)])]):_vm._e(),_vm._v(" "),(
            _vm.isMasterClassVisible ||
            _vm.isProviderVisible ||
            _vm.isPoolVisible ||
            _vm.isDriverVisible ||
            _vm.isPolicyVisible ||
            _vm.isVehicleVisible ||
            _vm.isRegionVisible
          )?_c('li',{staticClass:"nav-parent",attrs:{"id":"fleet-master"}},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nav-master",attrs:{"role":"menu"}},[(_vm.isMasterClassVisible)?_c('li',{staticClass:"nav-parent",attrs:{"id":"master-class"}},[_c('router-link',{attrs:{"to":"/fleet/class","id":"masterclass-link"}},[_vm._v("\n                Class Management")])],1):_vm._e(),_vm._v(" "),(_vm.isProviderVisible)?_c('li',[_c('router-link',{attrs:{"to":"/fleet/provider","id":"provider-link"}},[_vm._v("\n                Providers\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isDriverVisible)?_c('li',[_c('router-link',{attrs:{"to":"/fleet/driver","id":"driver-link"}},[_vm._v("\n                Drivers\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isVehicleVisible)?_c('li',[_c('router-link',{attrs:{"to":"/fleet/vehicle","id":"vehicle-link"}},[_vm._v("\n                Vehicles")])],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isZoneVisible)?_c('li',{staticClass:"nav-parent",attrs:{"id":"zone"}},[_c('router-link',{attrs:{"to":"/geofence","id":"zone-link"}},[_c('i',{staticClass:"ic-tour"}),_vm._v(" Geofence\n          ")])],1):_vm._e(),_vm._v(" "),(
            _vm.isBuyingTariffAncillaryRateVisible ||
            _vm.isBuyingTariffRentalChauffeurRateVisible ||
            _vm.isBuyingTariffRentalSelfDriveRateVisible ||
            _vm.isBuyingTariffTransferRateVisible ||
            _vm.isBuyingTariffOverriddenRentalChauffeurRateVisible ||
            _vm.isBuyingTariffOverriddenRentalSelfDriveRateVisible ||
            _vm.isBuyingTariffOverriddenTransferRateVisible ||
            _vm.isBuyingTariffOverriddenSurchargeVisible
          )?_c('li',{staticClass:"nav-parent",attrs:{"id":"buying-tariff"}},[_vm._m(3),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nav-master",attrs:{"role":"menu"}},[(
                _vm.isBuyingTariffRentalChauffeurRateVisible &&
                _vm.tariffScheme.globallyPerClass
              )?_c('li',[_c('router-link',{attrs:{"to":"/buying/hourly-chauffeur","id":"buying-rental-chauffeur-link-new"}},[_vm._v("\n                "+_vm._s(_vm.rentalLabel)+" ‐ Chauffeur\n              ")])],1):_vm._e(),_vm._v(" "),(
                _vm.isBuyingTariffRentalSelfDriveRateVisible &&
                _vm.tariffScheme.globallyPerClass
              )?_c('li',[_c('router-link',{attrs:{"to":"/buying/selfdrive","id":"buying-rental-selfdrive-link"}},[_vm._v("\n                "+_vm._s(_vm.rentalLabel)+" ‐ Self Drive\n              ")])],1):_vm._e(),_vm._v(" "),(
                _vm.isBuyingTariffTransferRateVisible &&
                _vm.tariffScheme.globallyPerClass
              )?_c('li',[_c('router-link',{attrs:{"to":"/buying/transfer","id":"buying-transfer-link-new"}},[_vm._v("\n                Transfer\n              ")])],1):_vm._e(),_vm._v(" "),(
                _vm.isBuyingTariffSurchargeVisible &&
                _vm.tariffScheme.globallyPerClass
              )?_c('li',[_c('router-link',{attrs:{"to":"/buying/surcharge","id":"buying-surcharge-link"}},[_vm._v("\n                Surcharges\n              ")])],1):_vm._e()])]):_vm._e(),_vm._v(" "),(
            _vm.isSellingTariffRentalChauffeurRateVisible ||
            _vm.isSellingTariffRentalSelfDriveRateVisible ||
            _vm.isSellingTariffTransferRateVisible ||
            _vm.isSellingTariffAncillaryRateVisible ||
            _vm.isSellingTariffSurchargeVisible ||
            _vm.isSellingTariffMarkupVisible ||
            _vm.isSellingTariffIncentiveVisible ||
            _vm.isSellingTariffIncentiveCompanyVisible
          )?_c('li',{staticClass:"nav-parent",attrs:{"id":"selling-tariff"}},[_vm._m(4),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nav-master",attrs:{"role":"menu"}},[(
                _vm.isSellingTariffRentalChauffeurRateVisible &&
                _vm.tariffScheme.globallyPerClass
              )?_c('li',[_c('router-link',{attrs:{"to":"/selling/hourly-chauffeur","id":"selling-rental-chauffeur-link-new"}},[_vm._v("\n                "+_vm._s(_vm.rentalLabel)+" ‐ Chauffeur\n              ")])],1):_vm._e(),_vm._v(" "),(
                _vm.isSellingTariffRentalSelfDriveRateVisible &&
                _vm.tariffScheme.globallyPerClass
              )?_c('li',[_c('router-link',{attrs:{"to":"/selling/selfdrive","id":"selling-rental-selfdrive-link"}},[_vm._v("\n                "+_vm._s(_vm.rentalLabel)+" ‐ Self Drive\n              ")])],1):_vm._e(),_vm._v(" "),(
                _vm.isSellingTariffTransferRateVisible &&
                _vm.tariffScheme.globallyPerClass
              )?_c('li',[_c('router-link',{attrs:{"to":"/selling/transfer","id":"selling-transfer-link-new"}},[_vm._v("\n                Transfer\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isSellingTariffAncillaryRateVisible)?_c('li',[_c('router-link',{attrs:{"to":"/selling/ancillary","id":"selling-ancillary-link"}},[_vm._v("\n                Ancillary\n              ")])],1):_vm._e(),_vm._v(" "),(
                _vm.isSellingTariffSurchargeVisible &&
                (_vm.tariffScheme.globallyPerClass ||
                  _vm.tariffScheme.vehicleOverrides)
              )?_c('li',[_c('router-link',{attrs:{"to":"/selling/surcharge","id":"selling-surcharge-link"}},[_vm._v("\n                Surcharges\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isSellingTariffMarkupVisible)?_c('li',[_c('router-link',{attrs:{"to":"/selling/markup","id":"selling-markup-link"}},[_vm._v("\n                Markup\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isSellingTariffIncentiveVisible)?_c('li',[_c('router-link',{attrs:{"to":"/selling/incentive","id":"selling-incentive-link"}},[_vm._v("\n                Incentives\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isSellingTariffIncentiveCompanyVisible)?_c('li',[_c('router-link',{attrs:{"to":"/selling/company-incentive","id":"selling-company-incentive-link"}},[_vm._v("\n                Company Incentives\n              ")])],1):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isCompanyVisible || _vm.isCustomerVisible)?_c('li',{staticClass:"nav-parent",attrs:{"id":"corporate"}},[_vm._m(5),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nav-master",attrs:{"role":"menu"}},[(_vm.isCompanyVisible)?_c('li',[_c('router-link',{attrs:{"to":"/corporate/company","id":"company-link"}},[_vm._v("\n                Company\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isCustomerVisible)?_c('li',[_c('router-link',{attrs:{"to":"/corporate/customer","id":"customer-link"}},[_vm._v("\n                Customer\n              ")])],1):_vm._e()])]):_vm._e(),_vm._v(" "),(
            _vm.userRoles.includes('Admin') ||
            _vm.userRoles.includes('Finance') ||
            _vm.userRoles.includes('Administrator')
          )?_c('li',{staticClass:"nav-parent",attrs:{"id":"deposit"}},[_vm._m(6),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nav-master",attrs:{"role":"menu"}},[_c('li',[_c('router-link',{attrs:{"to":"/finance/invoice","id":"invoice-link"}},[_vm._v("\n                Invoice\n              ")])],1)])]):_vm._e(),_vm._v(" "),(
            _vm.isSettingVisible ||
            _vm.isXrateVisible ||
            _vm.isShareVisible ||
            _vm.isPeakPeriodVisible ||
            _vm.isPickupOffsetVisible
          )?_c('li',{staticClass:"nav-parent",attrs:{"id":"administration"}},[_vm._m(7),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nav-master",attrs:{"role":"menu"}},[(_vm.isSettingVisible)?_c('li',[_c('router-link',{attrs:{"to":"/administration/setting","id":"setting-link"}},[_vm._v("\n                Global Settings\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isPeakPeriodVisible)?_c('li',[_c('router-link',{attrs:{"to":"/administration/peak-period","id":"public-holiday-link"}},[_vm._v("\n                Event Periods\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isPickupOffsetVisible)?_c('li',[_c('router-link',{attrs:{"to":"/administration/pickup-offset","id":"pickup-offset-link"}},[_vm._v("\n                Pick-up Offset\n              ")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/administration/rate-tagging","id":"rate-tagging-link"}},[_vm._v("\n                Custom Tags\n              ")])],1)])]):_vm._e(),_vm._v(" "),(
            _vm.isIdentityPolicyVisible ||
            _vm.isIdentityRoleVisible ||
            _vm.isIdentityUserVisible
          )?_c('li',{staticClass:"nav-parent",attrs:{"id":"security"}},[_vm._m(8),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nav-master",attrs:{"role":"menu"}},[(_vm.isIdentityPolicyVisible)?_c('li',[_c('router-link',{attrs:{"to":"/security/permission","id":"identity-policy-link"}},[_vm._v("\n                Permissions\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isIdentityRoleVisible)?_c('li',[_c('router-link',{attrs:{"to":"/security/role","id":"identity-role-link"}},[_vm._v("\n                Roles\n              ")])],1):_vm._e(),_vm._v(" "),(_vm.isIdentityUserVisible)?_c('li',[_c('router-link',{attrs:{"to":"/security/user","id":"identity-user-link"}},[_vm._v("\n                Users\n              ")])],1):_vm._e()])]):_vm._e()])]),_vm._v(" "),_vm._m(9)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown","aria-expanded":"true"}},[_c('i',{staticClass:"ic-transactional-report"}),_vm._v(" Reporting\n            "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown","aria-expanded":"true"}},[_c('i',{staticClass:"ic-booking-history"}),_vm._v(" Job Browser\n            "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown","aria-expanded":"true"}},[_c('i',{staticClass:"ic-car"}),_vm._v(" Fleet Master\n            "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown","aria-expanded":"true"}},[_c('i',{staticClass:"ic-price-calculator"}),_vm._v(" Operator Tariff\n            "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown","aria-expanded":"true"}},[_c('i',{staticClass:"ic-price-calculator"}),_vm._v(" Booker Tariff\n            "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown","aria-expanded":"true"}},[_c('i',{staticClass:"ic-office"}),_vm._v(" Corporate\n            "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown","aria-expanded":"true"}},[_c('i',{staticClass:"ic-wallet"}),_vm._v(" Finance\n            "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown","aria-expanded":"true"}},[_c('i',{staticClass:"ic-settings-horizontal"}),_vm._v(" Administration\n            "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown","aria-expanded":"true"}},[_c('i',{staticClass:"ic-manage-access"}),_vm._v(" Access Management\n            "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"left-menu--list bottom"},[_c('li',{staticClass:"hidden"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("\n            Feature Introduction\n            "),_c('span',{staticClass:"sts-brandNew"},[_vm._v("New")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://support.trransfer.com/","target":"_blank","id":"user-link"}},[_vm._v("\n            Help Center\n          ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(809);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c3cc276_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(1098);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c3cc276_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1092:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Disclaimer_vue__ = __webpack_require__(810);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a94568b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Disclaimer_vue__ = __webpack_require__(1093);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Disclaimer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a94568b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Disclaimer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1093:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"disclaimer-modal-input","role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content bsz"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"terms-wrapper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(1),_vm._v(" "),_c('h4',[_vm._v("Acceptance of terms through use please read")]),_vm._v(" "),_c('p',[_vm._v("\n                  This web site is an electronic news and information service of\n                  "+_vm._s(_vm.brands)+". You may print and keep a copy of this Agreement. By using\n                  this site, you signify your agreement to all terms, conditions, and\n                  notices contained or referenced herein (the \"Terms of Use\"). It is\n                  your responsibility to access this document whenever you visit this\n                  web site to determine if there have been any changes to the terms of\n                  the Terms of Use. If you do not agree to these Terms of Use please do\n                  not access or use this site. We reserve the right, at our discretion,\n                  to update or revise these Terms and Conditions of Use at any time.\n                  Please check the Terms periodically for changes. Your continued use of\n                  this site following the posting of any changes to the Terms of Use\n                  constitutes acceptance of those changes.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Copyright")]),_vm._v(" "),_c('p',[_vm._v("\n                  All content included on this site, such as text, graphics, logos,\n                  button icons, images, and audio clips, digital downloads, data\n                  compilations, and software, is the property of "+_vm._s(_vm.brands)+" or its\n                  content suppliers and protected by Singapore and international\n                  copyright laws. The compilation of all content on this site is the\n                  exclusive property of "+_vm._s(_vm.brands)+" and protected by Singapore and\n                  international copyright laws. All software used on this site is the\n                  property of "+_vm._s(_vm.brands)+" or its software suppliers and protected by\n                  Singapore and international copyright laws.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Trademark")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.brands)+" is a registered trademark of City DMC Pte Ltd in Singapore\n                  and other countries. "+_vm._s(_vm.brands)+" trademark and trade dress may not be\n                  used in connection with any product or service that is likely to cause\n                  confusion among customers, or in any manner that disparages or\n                  discredits "+_vm._s(_vm.brands)+". All other trademarks not owned by "+_vm._s(_vm.brands)+" or\n                  its subsidiaries that appear on this site are the property of their\n                  respective owners, who may or may not be affiliated with, connected\n                  to, or sponsored by "+_vm._s(_vm.brands)+" or its subsidiaries.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Proprietary rights")]),_vm._v(" "),_c('p',[_vm._v("\n                  You acknowledge and agree that all content and materials available on\n                  this site are protected by copyrights, trademarks, service marks,\n                  patents, trade secrets, or other proprietary rights and laws. Except\n                  as expressly authorized by "+_vm._s(_vm.brands)+", you agree not to sell, license,\n                  rent, modify, distribute, copy, reproduce, transmit, publicly display,\n                  publicly perform, publish, adapt, edit, or create derivative works\n                  from such materials or content. Notwithstanding the above, you may\n                  print or download one copy of the materials or content on this site on\n                  any single computer for your personal, non-commercial use, provided\n                  you keep intact all copyright and other proprietary notices.\n                  Systematic retrieval of data or other content from this site to create\n                  or compile, directly or indirectly, a collection, compilation,\n                  database or directory without written permission from "+_vm._s(_vm.brands)+" is\n                  prohibited. In addition, use of the content or materials for any\n                  purpose not expressly permitted in these Terms of Use is prohibited.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  As noted above, reproduction, copying, or redistribution for\n                  commercial purposes of any materials or design elements on this site\n                  is strictly prohibited without the express written permission of\n                  "+_vm._s(_vm.brands)+".\n                ")]),_vm._v(" "),_c('h4',[_vm._v("User’s grant of limited license")]),_vm._v(" "),_c('p',[_vm._v("\n                  By posting or submitting content to this site, you: a) "+_vm._s(_vm.brands)+" and\n                  its affiliates and licensees the right to use (in whole or part),\n                  reproduce, display, perform, edit, publish, translate, create\n                  derivative works from, adapt, modify, distribute, have distributed,\n                  and promote the content in any form, anywhere and for any purpose; and\n                  b) warrant and represent that you own or otherwise control all of the\n                  rights to the content and that public posting and use of your content\n                  by "+_vm._s(_vm.brands)+" will not infringe or violate the rights of any third\n                  party. You also warrant that any «moral rights» in your material have\n                  been waived.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Disclaimer of warranties")]),_vm._v(" "),_c('p',{staticClass:"uppercase"},[_vm._v("\n                  ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED\n                  IN OR AVAILABLE THROUGH THIS SITE (THE \"CONTENT\") ARE PROVIDED \"AS IS\"\n                  AND \"AS AVAILABLE\" FOR YOUR USE. THE SITE, INCLUDING, WITHOUT\n                  LIMITATION, ALL CONTENT, FUNCTIONS AND MATERIALS THEREON, IS PROVIDED\n                  \"AS IS,\" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED,\n                  INCLUDING, WITHOUT LIMITATION, ANY WARRANTY FOR INFORMATION, DATA,\n                  DATA PROCESSING SERVICES, OR UNINTERRUPTED ACCESS, ANY WARRANTIES\n                  CONCERNING THE AVAILABILITY, ACCURACY, USEFULNESS, OR CONTENT OF\n                  INFORMATION, AND ANY WARRANTIES OF TITLE, NON-INFRINGEMENT,\n                  MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. "+_vm._s(_vm.brands)+" DOES\n                  NOT WARRANT THAT THE SITE OR THE FUNCTIONS, FEATURES OR CONTENT\n                  CONTAINED THEREIN WILL BE TIMELY, SECURE, UNINTERRUPTED OR ERROR FREE,\n                  OR THAT DEFECTS WILL BE CORRECTED. "+_vm._s(_vm.brands)+" MAKES NO WARRANTY THAT\n                  THE SITE WILL MEET USERS' REQUIREMENTS. NO ADVICE, RESULTS OR\n                  INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM "+_vm._s(_vm.brands)+"\n                  OR THROUGH THE SITE SHALL CREATE ANY WARRANTY NOT EXPRESSLY MADE\n                  HEREIN. IF YOU ARE DISSATISFIED WITH THE SITE OR ANY CONTENT OR\n                  FUNCTION THEREON, YOUR SOLE REMEDY IS TO DISCONTINUE USING THE SITE.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Limitation of liabilities")]),_vm._v(" "),_c('p',{staticClass:"uppercase"},[_vm._v("\n                  UNDER NO CIRCUMSTANCES SHALL "+_vm._s(_vm.brands)+" OR ANY OF ITS DIRECTORS,\n                  OFFICERS, EMPLOYEES, AGENTS, AFFILIATES, SUBSIDIARIES OR ITS LICENSORS\n                  BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR\n                  CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY TO USE,\n                  THIS SITE. THIS LIMITATION APPLIES WHETHER THE ALLEGED LIABILITY IS\n                  BASED ON CONTRACT, TORT, NEGLIGENCE AND STRICT LIABILITY, INCLUDING,\n                  WITHOUT LIMITATION, LOSS OF REVENUE, OR ANTICIPATED PROFITS OR LOST\n                  BUSINESS OR LOST SALES, EVEN IF "+_vm._s(_vm.brands)+" HAS BEEN ADVISED OF THE\n                  POSSIBILITY OF SUCH DAMAGE. BECAUSE SOME JURISDICTIONS DO NOT ALLOW\n                  THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES,\n                  "+_vm._s(_vm.brands)+"’S LIABILITY IN SUCH JURISDICTIONS SHALL BE LIMITED TO THE\n                  EXTENT PERMITTED BY LAW.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Indemnification")]),_vm._v(" "),_c('p',[_vm._v("\n                  Upon a request by "+_vm._s(_vm.brands)+", you agree to defend, indemnify, and hold\n                  harmless "+_vm._s(_vm.brands)+" and its subsidiary and other affiliated companies,\n                  and their employees, contractors, officers, and directors from all\n                  liabilities, claims, and expenses, including attorney's fees that\n                  arise from your use or misuse of this site. "+_vm._s(_vm.brands)+" reserves the\n                  right, at its own expense, to assume the exclusive defense and control\n                  of any matter otherwise subject to indemnification by you, in which\n                  event you will cooperate with "+_vm._s(_vm.brands)+" in asserting any available\n                  defenses.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("International use")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.brands)+" makes no representation that materials on this site are\n                  appropriate or available for use in locations outside Singapore, and\n                  accessing them from territories where their contents are illegal is\n                  prohibited. Those who choose to access this site from other locations\n                  do so on their own initiative and are responsible for compliance with\n                  local laws.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Internet access")]),_vm._v(" "),_c('p',[_vm._v("\n                  You acknowledge and agree that in connection with your use of the Site\n                  you must: (a) provide for your own access to the World Wide Web and\n                  pay any service fees associated with such access, and (b) provide all\n                  equipment necessary for you to make such access and connection to the\n                  World Wide Web, including a computer, software, a modem and a means of\n                  connecting to or accessing the Internet. "+_vm._s(_vm.brands)+" shall not be\n                  responsible for any malfunctions, errors, crashes or other adverse\n                  events that may occur from your use of the Site.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Third party sites")]),_vm._v(" "),_c('p',[_vm._v("\n                  This site may produce automated search results or otherwise link you\n                  to other sites on the Internet. These sites may contain information or\n                  material that some people may find inappropriate or offensive. These\n                  other sites are not under the control of "+_vm._s(_vm.brands)+", and you\n                  acknowledge that "+_vm._s(_vm.brands)+" is not responsible or liable directly or\n                  indirectly for the accuracy, copyright compliance, legality, decency,\n                  or any other aspect of the content of such sites. The inclusion of\n                  such a link does not imply endorsement of the site by "+_vm._s(_vm.brands)+" or any\n                  association with its operators.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Unsolicited Material")]),_vm._v(" "),_c('p',[_vm._v("\n                  Unless specifically requested, "+_vm._s(_vm.brands)+" does not solicit nor does it\n                  wish to receive any confidential, secret or proprietary information or\n                  other material from you through the Site, any of its services, by\n                  e-mail, or in any other way.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Choice of law")]),_vm._v(" "),_c('p',[_vm._v("\n                  We control and operate this Site from our offices in Indonesia. Your\n                  use of this web site and all related rights and obligations, shall be\n                  governed by the Singapore laws. Any legal action or proceeding with\n                  respect to this web site, related to these Terms and Conditions of use\n                  or any matter related thereto may be brought exclusively in the courts\n                  of Singapore. By using this web site, you expressly agree and accept\n                  generally and unconditionally the jurisdiction of the aforesaid courts\n                  and irrevocably waive any objection to such jurisdiction.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Termination")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.brands)+" reserves the right, in its sole discretion, to terminate\n                  your access to all or part of this site, with or without notice.\n                ")]),_vm._v(" "),_c('h5',[_vm._v("©"+_vm._s(_vm.thisYear)+" "+_vm._s(_vm.brands))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default btn-back",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"ic-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"text-center"},[_c('strong',[_vm._v("DISCLAIMER")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1094:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__(811);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11588da0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__(1095);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11588da0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1095:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"policy-modal-input","role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content bsz"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"terms-wrapper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(1),_vm._v(" "),_c('h4',[_vm._v("Applicability")]),_vm._v(" "),_c('p',[_vm._v("\n                  By accessing and using this site, your use indicates your agreement\n                  with the terms of this Policy. If you do not agree with this Policy,\n                  please do not use this site.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  This Policy is applicable to this and certain other "+_vm._s(_vm.brands)+"\n                  web/mobile sites, but not necessarily, for which special terms and\n                  conditions may apply as indicated. All "+_vm._s(_vm.brands)+" sites to which this\n                  Policy is applicable are collectively referred to as this \"site\". Note\n                  that special use terms, or site or page specific terms (referred to as\n                  \"special terms\"), may apply to certain pages/services on this site,\n                  but the applicability of any such special terms will be expressly\n                  indicated. In the event of any inconsistency between any special terms\n                  and this Policy, the applicable special terms will prevail over the\n                  terms of this Policy.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Anonymous Use")]),_vm._v(" "),_c('p',[_vm._v("\n                  In general, most of this site's pages are provided for informational\n                  purposes and you will be able to use this site without telling\n                  "+_vm._s(_vm.brands)+" who you are or providing "+_vm._s(_vm.brands)+" with any personal data\n                  about yourself. There are times, however, when in connection with your\n                  use of this site "+_vm._s(_vm.brands)+" may need information about you.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Personal Data Provided by You")]),_vm._v(" "),_c('p',[_vm._v("\n                  To respond to your questions, fulfill your requests or manage\n                  interactive customer programs, it may be necessary to ask for or\n                  obtain personal data. If you provide us with any personal data, we may\n                  use it to respond to your requests, customize your user experience\n                  with us, determine your satisfaction with "+_vm._s(_vm.brands)+" products and/or\n                  services or contact you via mail, e-mail, mobile message or phone, or,\n                  in accordance with local law, contact you via the aforementioned\n                  channels to inform you of new products, services or promotions we may\n                  offer. By providing information to "+_vm._s(_vm.brands)+" through this site, you\n                  acknowledge and consent to the collection, use and disclosure of\n                  personally identifying information of the type and for the limited\n                  purposes described in this Policy.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  You expressly accept and give your consent that your personal data\n                  obtained in connection with your use of this site may be transferred,\n                  if permitted by applicable local legislation, across international\n                  borders to server locations supporting this site (including but not\n                  limited to transfers from those locations back to the country of your\n                  location) for operating and developing this site and "+_vm._s(_vm.brands)+"\n                  services, including transfers to "+_vm._s(_vm.brands)+" subcontractors or agents,\n                  as mentioned below, who perform tasks related to this site, or\n                  "+_vm._s(_vm.brands)+" services, or for the purposes of storing the data in\n                  relevant databases, which may be located in Singapore or in any other\n                  country where "+_vm._s(_vm.brands)+" has operations. If you place an order for a\n                  product, request a service or submit content to this site, we may need\n                  to contact you for additional information required to process or\n                  fulfill your order and/or request. Unless compelled by applicable law\n                  or administrative or judicial order, we will not provide this\n                  information to a third party without your permission, except as\n                  necessary to process your order, fulfill your requests, manage\n                  interactive customer programs or, if you are a corporate user, enable\n                  administration of access and usage of this site by authorized\n                  personnel in your organization. If allowed by applicable local\n                  legislation, "+_vm._s(_vm.brands)+" may also exchange information between\n                  "+_vm._s(_vm.brands)+"'s affiliated (related) companies for the purposes mentioned\n                  in this Policy.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  Because "+_vm._s(_vm.brands)+" is committed to protecting your privacy, "+_vm._s(_vm.brands)+"\n                  does not engage in the practice of selling or trading personal data to\n                  other companies for promotional purposes.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Usage of Subcontractors")]),_vm._v(" "),_c('p',[_vm._v("\n                  We may use subcontractors to provide some products or services to you.\n                  We also may need to share your personal data with these subcontractors\n                  so that they can provide services to us. Our subcontractors are not\n                  permitted to use such personal data for any other purposes and we\n                  impose confidentiality requirements on their services.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Visitor Identification - Usage of \"Cookies\"")]),_vm._v(" "),_c('p',[_vm._v("\n                  From time to time, information may be placed on your computer to\n                  improve this site and "+_vm._s(_vm.brands)+"'s services for you. This information\n                  is commonly referred to as a \"cookie\", which many web sites use.\n                  Cookies are pieces of data stored on your computer's hard drive or\n                  browser, and not on this site. They typically enable collection of\n                  certain information about your computer, including your internet\n                  protocol address, your computer's operating system, your browser type\n                  and the address of any referring sites. The use of cookies provides\n                  benefits to you, such as eliminating the need for you to enter your\n                  password frequently during a session, or, where applicable, re-enter\n                  items you place in a shopping cart from visit to visit if you do not\n                  finish a transaction on an earlier visit. By showing how and when our\n                  visitors use this site or other "+_vm._s(_vm.brands)+" sites, the use of cookies\n                  allows "+_vm._s(_vm.brands)+" to continue to improve the sites.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  If you do not wish to receive cookies, or want to be notified of when\n                  they are placed, you may set your web browser to do so, if your\n                  browser so permits. Please understand that if cookies are turned off,\n                  you may not be able to view certain parts of this site that may\n                  enhance your visit. Some of our business partners whose content is\n                  linked to or from this site may also use cookies. However, we have no\n                  access to or control over these cookies. This site also makes use of\n                  cookies for website traffic analysis and anonymous demographic\n                  profiling.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Disclaimer of warranties")]),_vm._v(" "),_c('p',{staticClass:"uppercase"},[_vm._v("\n                  ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED\n                  IN OR AVAILABLE THROUGH THIS SITE (THE \"CONTENT\") ARE PROVIDED \"AS IS\"\n                  AND \"AS AVAILABLE\" FOR YOUR USE. THE SITE, INCLUDING, WITHOUT\n                  LIMITATION, ALL CONTENT, FUNCTIONS AND MATERIALS THEREON, IS PROVIDED\n                  \"AS IS,\" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED,\n                  INCLUDING, WITHOUT LIMITATION, ANY WARRANTY FOR INFORMATION, DATA,\n                  DATA PROCESSING SERVICES, OR UNINTERRUPTED ACCESS, ANY WARRANTIES\n                  CONCERNING THE AVAILABILITY, ACCURACY, USEFULNESS, OR CONTENT OF\n                  INFORMATION, AND ANY WARRANTIES OF TITLE, NON-INFRINGEMENT,\n                  MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. "+_vm._s(_vm.brands)+" DOES\n                  NOT WARRANT THAT THE SITE OR THE FUNCTIONS, FEATURES OR CONTENT\n                  CONTAINED THEREIN WILL BE TIMELY, SECURE, UNINTERRUPTED OR ERROR FREE,\n                  OR THAT DEFECTS WILL BE CORRECTED. "+_vm._s(_vm.brands)+" MAKES NO WARRANTY THAT\n                  THE SITE WILL MEET USERS' REQUIREMENTS. NO ADVICE, RESULTS OR\n                  INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM "+_vm._s(_vm.brands)+"\n                  OR THROUGH THE SITE SHALL CREATE ANY WARRANTY NOT EXPRESSLY MADE\n                  HEREIN. IF YOU ARE DISSATISFIED WITH THE SITE OR ANY CONTENT OR\n                  FUNCTION THEREON, YOUR SOLE REMEDY IS TO DISCONTINUE USING THE SITE.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Security")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.brands)+" has endeavored to take commercially reasonable measures to\n                  prevent unauthorized access to and improper use of your personal data\n                  submitted to "+_vm._s(_vm.brands)+" via your use of this site. For example,\n                  "+_vm._s(_vm.brands)+" uses encryption technology when collecting financial\n                  personal data such as credit card information. If this site supports\n                  on-line transactions, it will use an industry standard security\n                  measure, such as the one available through \"Secure Sockets Layer\"\n                  (\"SSL\"), to protect the confidentiality and security of online\n                  transactions. If used, industry standard security measures like SSL\n                  authentication ensure that credit card information, as well as other\n                  personal data submitted as part of the buying process, is reasonably\n                  safe from third party interception.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  While there are always risks associated with providing personal data,\n                  whether in person, by phone or via the internet or other technologies,\n                  and no system of technology is completely safe or \"tamper\"/\"hacker\"\n                  proof, "+_vm._s(_vm.brands)+" has endeavored to take reasonable precautions which\n                  are appropriate to the nature of the information to prevent and\n                  minimize such risks in connection with your use of this site.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Accuracy of Collected Data")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.brands)+" will on its own initiative, or at your request, free of\n                  charge, replenish, rectify or erase any incomplete, inaccurate or\n                  outdated personal data retained by "+_vm._s(_vm.brands)+" in connection with the\n                  operation of this site. Please consult the contact information posted\n                  below on this page, if any, or elsewhere on this site to determine how\n                  best to contact "+_vm._s(_vm.brands)+" to update and/or review your personal data\n                  and/or opt out of receiving marketing communications from "+_vm._s(_vm.brands)+".\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Minors")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.brands)+"'s policy is to request that \"Minors\" (the age of Minors is\n                  determined by local law where you reside) do not make purchases or\n                  engage in other legal acts on this site without the consent of a\n                  parent or legal guardian, unless permitted by applicable local law.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("External Links")]),_vm._v(" "),_c('p',[_vm._v("\n                  This site may contain links to other sites. Please note that "+_vm._s(_vm.brands)+"\n                  is not responsible for the privacy practices or contents of any other\n                  sites. We recommend that you read the privacy policies of such sites.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("Changes to this Policy")]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.brands)+" may from time to time change this Policy or change, modify\n                  or withdraw access to this site at any time with or without notice.\n                  However, if this Policy is changed in a material, adverse way,\n                  "+_vm._s(_vm.brands)+" will post a notice advising of such change at the beginning\n                  of this Policy and on this site's home page for 30 days. We recommend\n                  that you re-visit this Policy from time to time to learn of any such\n                  changes to this Policy.\n                ")]),_vm._v(" "),_c('h5',[_vm._v("©"+_vm._s(_vm.thisYear)+" "+_vm._s(_vm.brands))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default btn-back",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"ic-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"text-center"},[_c('strong',[_vm._v("PRIVACY AND POLICY")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1096:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__ = __webpack_require__(812);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df5833b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__ = __webpack_require__(1097);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2df5833b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1097:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"terms-modal-input","role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content bsz"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"terms-wrapper"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(1),_vm._v(" "),_c('p',[_vm._v("\n                  These terms will apply to your use of our site, which includes\n                  accessing our site, browsing it, or registering to use any of our\n                  services. Please read these terms carefully before you start to use\n                  our site because, by using it, you confirm that you accept these terms\n                  and that you agree to comply with them and any applicable laws and\n                  regulations. If you do not agree to these terms, you must not use our\n                  site.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  These terms of use (together with the documents referred to in them)\n                  tell you the terms on which you may make use of our website and any of\n                  its sub domains (“our site”), whether as a guest or a registered\n                  member.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  If you are using our site on behalf of an organization of which you\n                  are an employee, officer, agent or other contractor, such organization\n                  will be responsible to us for ensuring you and any other person who\n                  uses our site on the organization’s behalf complies with these terms\n                  of use. You confirm that you have the authority to accept such\n                  responsibility on behalf of your organization.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("OTHER APPLICABLE TERMS")]),_vm._v(" "),_c('p',[_vm._v("\n                  These terms of use refer to our privacy and cookies policy, which also\n                  applies to your use of our site.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  We make certain content on our site available to all users. However,\n                  registered users are able to see other parts of our site that contain\n                  confidential information. You will need to register as a user and\n                  agree to a non-disclosure agreement in order to see such information.\n                  The terms of the non-disclosure agreement form part of our agreement\n                  with registered users.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  For regulatory and legal reasons, before you are able to see details\n                  of any live investment opportunity, or invest in any opportunity on\n                  our site, you will need to confirm that you fall within a category of\n                  permitted investors and agree to additional terms and conditions\n                  governing each investment on our site (a “subscription agreement”). We\n                  will make the subscription agreement available to you before you\n                  invest in any opportunity. The terms of the subscription agreement\n                  will apply to your use of our site once you have agreed to the\n                  subscription agreement.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("CHANGE TO THESE TERMS AND OUR SITE")]),_vm._v(" "),_c('p',[_vm._v("\n                  We may revise these terms of use at any time by amending this page.\n                  Please check this page from time to time to take notice of any changes\n                  we make, as they are binding on you.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  We may update our site from time to time and may change the content at\n                  any time. However, please note that any of the content on our site\n                  could be out of date at any given time and we are under no obligation\n                  to update it.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("ACCESSING OUR SITE")]),_vm._v(" "),_c('p',[_vm._v("Our site is made available free of charge.")]),_vm._v(" "),_c('p',[_vm._v("\n                  We reserve the right to restrict access to some parts of our site to\n                  registered users and registered investors.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  We do not guarantee that our site, or any content on it, will always\n                  be available or be uninterrupted or that it will be free from errors.\n                  Access to our site is permitted on a temporary basis. We may suspend,\n                  withdraw, discontinue or change all or any part of our site without\n                  notice. We will not be liable to you if for any reason our site is\n                  unavailable at any time or for any period.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  You are responsible for making all arrangements necessary for you to\n                  have access to our site.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  You are also responsible for ensuring that all persons who access our\n                  site through your internet connection are aware of these terms of use\n                  and other applicable terms and conditions, and that they comply with\n                  them.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("ACCOUNTS AND PASSWORDS")]),_vm._v(" "),_c('p',[_vm._v("\n                  If you choose, or you are provided with, a user identification code,\n                  password or any other piece of information as part of our security\n                  procedures, you must treat such information as confidential. You must\n                  not disclose it to any other person.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  We have the right to disable any user identification code or password,\n                  whether chosen by you or allocated by us, at any time, if in our\n                  reasonable opinion you have failed to comply with any of the\n                  provisions of these terms of use.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  If you know or suspect that anyone other than you know your user\n                  identification code or password, you must promptly notify us.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("INTELLECTUAL PROPERTY RIGHTS")]),_vm._v(" "),_c('p',[_vm._v("\n                  We are the owner or the licensee of all intellectual property rights\n                  in our site, including the material published on it and the software\n                  and programming behind our site. Those works are protected by\n                  copyright laws and treaties around the world. All such rights are\n                  reserved.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  You may print off one copy, and may download extracts, of any page(s)\n                  from our site for your personal use and you may draw the attention of\n                  others within your organization to content posted on our site. You\n                  must not use our content in a way that may:\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  be defamatory, deceptive or misleading, obscene, offensive, sexually\n                  explicit, hateful or inflammatory or to harass, upset, embarrass,\n                  alarm or annoy any other person or invade any person’s privacy;\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  promote discrimination on race, sex, religion, nationality,\n                  disability, sexual orientation or age, sexually explicit material,\n                  violence or any illegal activity;\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  infringe any copyright, database right or trade mark of any person;\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  breach any legal duty owed to a third party, such as a contractual\n                  duty or a duty of confidence;\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  give the impression that it emanates from us, if this is not the case;\n                  or\n                ")]),_vm._v(" "),_c('p',[_vm._v("assist any unlawful act.")]),_vm._v(" "),_c('p',[_vm._v("\n                  Our status (and that of any identified contributors) as the authors of\n                  content on our site must always be acknowledged.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  If you print off, copy or download any part of our site in breach of\n                  these terms of use, your right to use our site will cease immediately\n                  and you must, at our option, return or destroy any copies of the\n                  materials you have made.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("RELIANCE ON INFORMATION")]),_vm._v(" "),_c('p',[_vm._v("\n                  The content on our site is provided for general information only. It\n                  is not intended to amount to advice on which you should rely. You must\n                  obtain professional or specialist advice before taking, or refraining\n                  from, any action on the basis of the content on our site.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  Although we make reasonable efforts to update the information on our\n                  site, we make no representations, warranties or guarantees, whether\n                  express or implied, that the content on our site is accurate, complete\n                  or up-to-date.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("LIMITATION ON OUR LIABILITY")]),_vm._v(" "),_c('p',[_vm._v("\n                  Nothing in these terms of use excludes or limits our liability for\n                  death or personal injury arising from our negligence, or our fraud or\n                  fraudulent misrepresentation, or any other liability that cannot be\n                  excluded or limited by Singapore law.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  To the extent permitted by law, we exclude all conditions, warranties,\n                  representations or other terms which may apply to our site or any\n                  content on it, whether express or implied. We will not be liable to\n                  any user for any loss or damage, whether in contract, tort (including\n                  negligence), breach of statutory duty or otherwise, even if\n                  foreseeable, arising under or in connection with your use of, or\n                  inability to use, our site or your reliance on any content on our\n                  site.\n                ")]),_vm._v(" "),_c('p',[_vm._v("We will not be liable to you for:")]),_vm._v(" "),_c('p',[_vm._v("loss of profits, sales, business, or revenue;")]),_vm._v(" "),_c('p',[_vm._v("business interruption;")]),_vm._v(" "),_c('p',[_vm._v("loss of anticipated savings;")]),_vm._v(" "),_c('p',[_vm._v("loss of business opportunity, goodwill or reputation; or")]),_vm._v(" "),_c('p',[_vm._v("any indirect or consequential loss or damage.")]),_vm._v(" "),_c('h4',[_vm._v("UPLOADING CONTENT TO OUR SITE")]),_vm._v(" "),_c('p',[_vm._v("\n                  Whenever you make use of a feature that allows you to upload or post\n                  content to or on our site, or to make contact with other users of our\n                  site, you must comply with the content standards set out in these\n                  terms of use.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  Any content uploaded or posted by you (“Your Content”) must be\n                  accurate (where it states facts), be genuinely held (where it states\n                  opinions) and comply with applicable law in the SG and any other\n                  country from which it is sent. Your Content must not:\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  be defamatory, deceptive or misleading, obscene, offensive, sexually\n                  explicit, hateful or inflammatory or likely to harass, upset,\n                  embarrass, alarm or annoy any other person or invade any person’s\n                  privacy;\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  promote discrimination on race, sex, religion, nationality,\n                  disability, sexual orientation or age, sexually explicit material,\n                  violence or any illegal activity;\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  infringe any copyright, database right or trade mark of any person;\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  breach any legal duty owed to a third party, such as a contractual\n                  duty or a duty of confidence;\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  give the impression that it emanates from us, if this is not the case;\n                  or\n                ")]),_vm._v(" "),_c('p',[_vm._v("assist any unlawful act.")]),_vm._v(" "),_c('p',[_vm._v("\n                  You agree that Your Content will comply with the standards set out in\n                  these terms. Your content will be considered non-confidential and\n                  non-proprietary. You grant the following royalty free, perpetual,\n                  non-exclusive licenses in relation to Your Content:\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  a license for us to use Your Content for all purposes in connection\n                  with our business.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  a license for all other visitors to our site to use any of Your\n                  Content for all purposes in connection with their use of our site.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  We may disclose your identity to any third party who is claiming that\n                  any of Your Content constitutes a violation of their intellectual\n                  property rights, or of their right to privacy.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  We may also remove all or any of Your Content from the Website if, in\n                  our opinion, it does not comply with these terms of use.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  The views expressed by other visitors to our site do not represent our\n                  views or values.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("VIRUSES")]),_vm._v(" "),_c('p',[_vm._v("\n                  We do not guarantee that our site will be secure or free from bugs or\n                  viruses. We will not be liable for any loss or damage caused by a\n                  virus, distributed denial-of-service attack or other technologically\n                  harmful material that may infect your computer equipment, computer\n                  programs, data or other proprietary material due to your use of our\n                  site, or to your downloading of any content on it, or on any website\n                  linked to it. You should use your own virus protection software.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  You must not misuse our site by knowingly introducing viruses,\n                  trojans, worms, logic bombs or other material which is malicious or\n                  technologically harmful. You must not attempt to gain unauthorized\n                  access to our site, the server on which our site is stored or any\n                  server, computer or database connected to our site. You must not\n                  attack our site via a denial-of-service attack or a distributed\n                  denial-of service attack.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("LINKING TO OUR SITE")]),_vm._v(" "),_c('p',[_vm._v("\n                  You may link to our home page, provided you do so in a way that is\n                  fair and legal and does not damage our reputation or take advantage of\n                  it. We reserve the right to withdraw linking permission without\n                  notice.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  You must not establish a link in such a way as to suggest any form of\n                  association, approval or endorsement on our part where none exists or\n                  establish a link to our site in any website that is not owned by you.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  Our site must not be framed on any other site and you may not create a\n                  link to any part of our site other than the home page.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("THIRD PARTY LINKS AND RESOURCES ON OUR SITE")]),_vm._v(" "),_c('p',[_vm._v("\n                  Where our site contains links to other sites and resources provided by\n                  third parties, these links are provided for your information only.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                  We have no control over the contents of those sites or resources and\n                  assume no responsibility for those contents. Such links should not be\n                  interpreted as endorsement by us of those linked websites. We will not\n                  be liable for any loss or damage that may arise from your use of them.\n                ")]),_vm._v(" "),_c('h4',[_vm._v("APPLICABLE LAW")]),_vm._v(" "),_c('p',[_vm._v("\n                  These terms of use are governed by Singapore law. You and we both\n                  agree to that the courts of Singapore will have non-exclusive\n                  jurisdiction to deal with any disputes arising in relation to your use\n                  of our site.\n                ")]),_vm._v(" "),_c('h5',[_vm._v("©"+_vm._s(_vm.thisYear)+" "+_vm._s(_vm.brands))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default btn-back",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"ic-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"text-center"},[_c('strong',[_vm._v("TERMS OF USE")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"option__box-footer clearfix"},[_c('div',{staticClass:"pl-15"},[_c('div',{staticClass:"navbar-brand-footer pull-left"},[_c('img',{attrs:{"src":_vm.logo,"target":"_blank","alt":"Trransfer"}})])])])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"copyright"},[_vm._v("\n          ©"+_vm._s(_vm.thisYear)+" All rights reserved. Powered by\n          "),_c('a',{staticClass:"backlink",attrs:{"href":_vm.productUrl,"target":"_blank"}},[_vm._v("\n            "+_vm._s(_vm.productTitle)+"\n          ")])])])]),_vm._v(" "),_c('disclaimer'),_vm._v(" "),_c('privacyPolicy'),_vm._v(" "),_c('termsOfUse')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 pull-right"},[_c('div',{staticClass:"right-footer"},[_c('div',{staticClass:"row text-center mt-15"},[_c('li',{staticClass:"col-sm-4"}),_vm._v(" "),_c('li',{staticClass:"col-sm-4"}),_vm._v(" "),_c('li',{staticClass:"col-sm-4"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-progress-bar'),_vm._v(" "),(_vm.isAuthorized)?_c('div',{attrs:{"id":"wrapper"}},[_c('Navigation'),_vm._v(" "),_c('Header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('Footer')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__ = __webpack_require__(806);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec570000_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__ = __webpack_require__(1099);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec570000_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var _guardCallback = function _guardCallback(arg) {
  if (typeof arg === "function") {
    arg();
  }
};

var _onError = function _onError(error) {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (var index = 0; index < error.response.data.errors.length; index++) {
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Request failed with status code " + error.response.status, { title: "Error" });
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

var syncApi = {
  get: function get(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  post: function post(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  put: function put(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  delete: function _delete(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  getWithOptions: function getWithOptions(url, option, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  postWithOptions: function postWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  putWithOptions: function putWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  }
};

var asyncApi = {
  get: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _guardCallback(onBeginCallback);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _onError(_context.t0));

            case 11:
              _context.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }));

    return function get(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  post: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _guardCallback(onBeginCallback);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", onErrorCallback(_context2.t0.response.data));

            case 12:
              return _context2.abrupt("return", _onError(_context2.t0));

            case 13:
              _context2.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8, 13, 16]]);
    }));

    return function post(_x4, _x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }(),
  put: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _guardCallback(onBeginCallback);
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", onErrorCallback(_context3.t0.response.data));

            case 12:
              return _context3.abrupt("return", _onError(_context3.t0));

            case 13:
              _context3.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8, 13, 16]]);
    }));

    return function put(_x9, _x10, _x11, _x12, _x13) {
      return _ref3.apply(this, arguments);
    };
  }(),
  delete: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _guardCallback(onBeginCallback);
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", _onError(_context4.t0));

            case 11:
              _context4.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 8, 11, 14]]);
    }));

    return function _delete(_x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getWithOptions: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url, option, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              _guardCallback(onBeginCallback);
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", _onError(_context5.t0));

            case 11:
              _context5.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context5.finish(11);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[0, 8, 11, 14]]);
    }));

    return function getWithOptions(_x17, _x18, _x19, _x20) {
      return _ref5.apply(this, arguments);
    };
  }(),
  postWithOptions: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              _guardCallback(onBeginCallback);
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _onError(_context6.t0));

            case 11:
              _context6.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context6.finish(11);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[0, 8, 11, 14]]);
    }));

    return function postWithOptions(_x21, _x22, _x23, _x24, _x25) {
      return _ref6.apply(this, arguments);
    };
  }(),
  putWithOptions: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              _guardCallback(onBeginCallback);
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _onError(_context7.t0));

            case 11:
              _context7.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[0, 8, 11, 14]]);
    }));

    return function putWithOptions(_x26, _x27, _x28, _x29, _x30) {
      return _ref7.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__(500);



var _this = this;



var _baseEndpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/lookup";

/* harmony default export */ __webpack_exports__["a"] = ({
  availableEvent: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/trip-log/available-event", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function availableEvent(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(),
  chauffeurCommon: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/rental-type/chauffeur", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function chauffeurCommon(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(),
  selfdriveCommon: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/rental-type/self-drive", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function selfdriveCommon(_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }(),
  supportedCurrencies: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/supported-currencies", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function supportedCurrencies(_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }()
});

/***/ }),

/***/ 806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_Header__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_Navigation__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_Footer__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_index_js__ = __webpack_require__(40);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AppLayout",
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_2__components_shared_Header__["a" /* default */],
    Navigation: __WEBPACK_IMPORTED_MODULE_3__components_shared_Navigation__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_4__components_shared_Footer__["a" /* default */]
  },
  data: function data() {
    return {
      isAuthorized: false
    };
  },
  created: function created() {
    this.authorize();
  },
  updated: function updated() {
    this.authorize();
    // HACK: treat normal textbox as a readonly element, value can't be edited manually
    Array.prototype.forEach.call(document.getElementsByClassName("readonly"), function (element) {
      element.addEventListener("keydown", function (event) {
        event.preventDefault();
      });
    });
  },

  methods: {
    authorize: function authorize() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__store_index_js__["a" /* default */].dispatch("user/getUser");

              case 3:
                user = _context.sent;

                if (user.active) {
                  _this.isAuthorized = user.active;
                } else {
                  console.log("User not signed in");
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  }
});

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_constants__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_shop_lookup_lookupService_js__ = __webpack_require__(598);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { Currencies } from "@/models/constants";



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    transactionCurrency: function transactionCurrency() {
      return this.$store.state.setting.transactionCurrency;
    },
    profileInitial: function profileInitial() {
      if (this.profile) {
        if (this.profile.firstName && this.profile.lastName) {
          return ("" + this.profile.firstName[0] + this.profile.lastName[0]).toUpperCase();
        } else {
          var profileName = this.profile.firstName.split(" ");
          if (profileName.length > 1) {
            var firstWord = profileName[0];
            var lastWord = profileName[profileName.length - 1];
            return ("" + firstWord[0] + lastWord[0]).toUpperCase();
          } else {
            return ("" + this.profile.firstName[0] + this.profile.firstName[this.profile.firstName.length - 1]).toUpperCase();
          }
        }
      }
      return "";
    },
    profileFirstName: function profileFirstName() {
      return this.profile && this.profile.firstName ? this.profile.firstName.charAt(0).toUpperCase() + this.profile.firstName.slice(1) : "";
    },
    profileLastName: function profileLastName() {
      return this.profile && this.profile.lastName ? this.profile.lastName.charAt(0).toUpperCase() + this.profile.lastName.slice(1) : "";
    },
    profileName: function profileName() {
      return this.profileFirstName || this.profileLastName ? this.profileFirstName + " " + this.profileLastName : "";
    },
    profileUsername: function profileUsername() {
      return this.profile ? this.profile.username : "";
    },
    isMainMenuDisplayed: function isMainMenuDisplayed() {
      return this.$route.name === "Home";
    },
    isReservationStepDisplayed: function isReservationStepDisplayed() {
      return this.$route.name === "ReservationForm";
    },
    cdn: function cdn() {
      return "https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com";
    },
    getSelectedCurrency: function getSelectedCurrency() {
      return localStorage.getItem("selectedCurrency") || "SGD";
    }
  },
  data: function data() {
    return {
      rentalLabel: null,
      airportLabel: null,
      smallLogo: null,
      opsigoLogo: null,
      productUrl: null,
      productTitle: null,
      profile: null,
      currencies: [],
      UserType: __WEBPACK_IMPORTED_MODULE_2__models_constants__["p" /* UserType */]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;
              _context.next = 5;
              return _this.$store.dispatch("user/getProfile");

            case 5:
              _this.profile = _context.sent;
              _context.next = 8;
              return _this.getSupportedCurrencies();

            case 8:

              _this.rentalLabel = _this.$helper.extractSetting(publicSettings, "RentalLabel", "Hourly");
              _this.airportLabel = _this.$helper.extractSetting(publicSettings, "AirportLabel", "Airport Trans");
              _this.smallLogo = _this.$helper.extractSetting(publicSettings, "MainLogo", _this.cdn + "/images/logo-icon-text.png");
              _this.opsigoLogo = _this.$helper.extractSetting(publicSettings, "OpsigoLogo", _this.cdn + "/images/small-logo.svg");
              _this.productUrl = _this.$helper.extractSetting(publicSettings, "ProductUrl", "https://trransfer.com");
              _this.productTitle = _this.$helper.extractSetting(publicSettings, "ProductTitle", "Trransfer");

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    $(".navbar-toggle").off("click").on("click", function () {
      $(".left-menu").toggleClass("isActive");
      $(".overlay").show();
    });
  },

  methods: {
    getSupportedCurrencies: function getSupportedCurrencies() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_shop_lookup_lookupService_js__["a" /* default */].supportedCurrencies();

              case 2:
                response = _context2.sent;


                if (response.isSuccess) {
                  _this2.currencies = response.data.map(function (curr) {
                    return {
                      text: curr.name,
                      value: curr.code
                    };
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    onClickRental: function onClickRental() {
      // publish message
      this.$eventBus.$emit("navigateToVehicleRental");
    },
    onClickAirportTransfer: function onClickAirportTransfer() {
      // publish message
      this.$eventBus.$emit("navigateToAirportTransfer");
    },
    setCurrency: function setCurrency(value) {
      localStorage.setItem("selectedCurrency", value);
      location.reload();
    }
  }
});

/***/ }),

/***/ 808:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_constants__ = __webpack_require__(237);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isServicesExist: function isServicesExist() {
      return this.allServices && this.allServices !== null;
    },
    isVehicleRepairementVisible: function isVehicleRepairementVisible() {
      return this.isServicesExist && (this.allServices["VehicleRepairement"] || this.allServices["VehicleRepairementItem"]);
    },
    isTenantReportVisible: function isTenantReportVisible() {
      return this.isServicesExist && this.allServices["TenantReport"];
    },
    isProviderReportVisible: function isProviderReportVisible() {
      return this.isServicesExist && this.allServices["ProviderReport"];
    },
    isCustomerReportVisible: function isCustomerReportVisible() {
      return this.isServicesExist && this.allServices["CustomerReport"];
    },
    isAvailableJobVisible: function isAvailableJobVisible() {
      return this.isServicesExist && this.allServices["AvailableJob"];
    },
    isTenantJobVisible: function isTenantJobVisible() {
      return this.isServicesExist && this.allServices["TenantJob"];
    },
    isProviderJobVisible: function isProviderJobVisible() {
      return this.isServicesExist && this.allServices["ProviderJob"];
    },
    isDriverJobVisible: function isDriverJobVisible() {
      return this.isServicesExist && this.allServices["DriverJob"];
    },
    isProviderVisible: function isProviderVisible() {
      return this.isServicesExist && this.allServices["Provider"];
    },
    isPoolVisible: function isPoolVisible() {
      return this.isServicesExist && this.allServices["Pool"];
    },
    isDriverVisible: function isDriverVisible() {
      return this.isServicesExist && this.allServices["Driver"];
    },
    isPolicyVisible: function isPolicyVisible() {
      return this.isServicesExist && this.allServices["Policy"];
    },
    isVehicleVisible: function isVehicleVisible() {
      return this.isServicesExist && this.allServices["Vehicle"];
    },
    isPeakPeriodVisible: function isPeakPeriodVisible() {
      return this.isServicesExist && this.allServices["PeakPeriod"];
    },
    isShareVisible: function isShareVisible() {
      return this.isServicesExist && this.allServices["Share"];
    },
    isMasterClassVisible: function isMasterClassVisible() {
      return this.isServicesExist && this.allServices["MasterClass"];
    },
    isCompanyVisible: function isCompanyVisible() {
      return this.isServicesExist && this.allServices["Company"];
    },
    isCustomerVisible: function isCustomerVisible() {
      return this.isServicesExist && this.allServices["Customer"];
    },
    isDepositSummaryVisible: function isDepositSummaryVisible() {
      return this.isServicesExist && this.allServices["Deposit"];
    },
    isDepositTopupDemandVisible: function isDepositTopupDemandVisible() {
      return this.isServicesExist && this.allServices["DepositTopup"];
    },
    isDepositTopupApprovalVisible: function isDepositTopupApprovalVisible() {
      return this.isServicesExist && this.allServices["DepositTopup"];
    },
    isDepositRefundDemandVisible: function isDepositRefundDemandVisible() {
      return this.isServicesExist && this.allServices["DepositRefund"];
    },
    isDepositRefundApprovalVisible: function isDepositRefundApprovalVisible() {
      return this.isServicesExist && this.allServices["DepositRefund"];
    },
    isDepositHistoryVisible: function isDepositHistoryVisible() {
      return this.isServicesExist && this.allServices["DepositHistory"];
    },
    isRegionVisible: function isRegionVisible() {
      return this.isServicesExist && this.allServices["Region"];
    },
    isPickupOffsetVisible: function isPickupOffsetVisible() {
      return this.isServicesExist && this.allServices["PickUpOffset"];
    },
    isZoneVisible: function isZoneVisible() {
      return this.isServicesExist && this.allServices["Zone"];
    },
    isXrateVisible: function isXrateVisible() {
      return this.isServicesExist && this.allServices["ExchangeRate"];
    },
    isProviderCandidateVisible: function isProviderCandidateVisible() {
      return this.isServicesExist && this.allServices["OnBoarding"];
    },
    isSettingVisible: function isSettingVisible() {
      return this.isServicesExist && this.allServices["Setting"];
    },
    isIdentityPolicyVisible: function isIdentityPolicyVisible() {
      return this.isServicesExist && this.allServices["IdentityPolicy"];
    },
    isIdentityRoleVisible: function isIdentityRoleVisible() {
      return this.isServicesExist && this.allServices["IdentityRole"];
    },
    isIdentityUserVisible: function isIdentityUserVisible() {
      return this.isServicesExist && this.allServices["IdentityUser"];
    },
    isBuyingTariffAncillaryRateVisible: function isBuyingTariffAncillaryRateVisible() {
      // return this.isServicesExist && this.allServices["BuyingTariffAncillaryRate"];
      return false;
    },
    isBuyingTariffRentalChauffeurRateVisible: function isBuyingTariffRentalChauffeurRateVisible() {
      return this.isServicesExist && this.allServices["BuyingTariffRentalChauffeurRate"];
    },
    isBuyingTariffRentalSelfDriveRateVisible: function isBuyingTariffRentalSelfDriveRateVisible() {
      return this.isServicesExist && this.allServices["BuyingTariffRentalSelfDriveRate"];
    },
    isBuyingTariffTransferRateVisible: function isBuyingTariffTransferRateVisible() {
      return this.isServicesExist && this.allServices["BuyingTariffTransferRate"];
    },
    isBuyingTariffOverriddenRentalChauffeurRateVisible: function isBuyingTariffOverriddenRentalChauffeurRateVisible() {
      return this.isServicesExist && this.allServices["BuyingTariffOverriddenRentalChauffeurRate"];
    },
    isBuyingTariffOverriddenRentalSelfDriveRateVisible: function isBuyingTariffOverriddenRentalSelfDriveRateVisible() {
      return this.isServicesExist && this.allServices["BuyingTariffOverriddenRentalSelfDriveRate"];
    },
    isBuyingTariffOverriddenTransferRateVisible: function isBuyingTariffOverriddenTransferRateVisible() {
      return this.isServicesExist && this.allServices["BuyingTariffOverriddenTransferRate"];
    },
    isBuyingTariffSurchargeVisible: function isBuyingTariffSurchargeVisible() {
      return this.isServicesExist && (this.allServices["BuyingTariffGeneralSurcharge"] || this.allServices["BuyingTariffCancellationSurcharge"] || this.allServices["BuyingTariffPeakPeriodSurcharge"] || this.allServices["BuyingTariffWaitingTimeSurcharge"]);
    },
    isBuyingTariffOverriddenSurchargeVisible: function isBuyingTariffOverriddenSurchargeVisible() {
      return this.isServicesExist && (this.allServices["BuyingTariffOverriddenGeneralSurcharge"] || this.allServices["BuyingTariffOverriddenCancellationSurcharge"] || this.allServices["BuyingTariffOverriddenPeakPeriodSurcharge"] || this.allServices["BuyingTariffOverriddenWaitingTimeSurcharge"]);
    },
    isSellingTariffAncillaryRateVisible: function isSellingTariffAncillaryRateVisible() {
      return this.isServicesExist && this.allServices["SellingTariffAncillaryRate"];
    },
    isSellingTariffRentalChauffeurRateVisible: function isSellingTariffRentalChauffeurRateVisible() {
      return this.isServicesExist && this.allServices["SellingTariffRentalChauffeurRate"];
    },
    isSellingTariffRentalSelfDriveRateVisible: function isSellingTariffRentalSelfDriveRateVisible() {
      return this.isServicesExist && this.allServices["SellingTariffRentalSelfDriveRate"];
    },
    isSellingTariffTransferRateVisible: function isSellingTariffTransferRateVisible() {
      return this.isServicesExist && this.allServices["SellingTariffTransferRate"];
    },
    isSellingTariffSurchargeVisible: function isSellingTariffSurchargeVisible() {
      return this.isServicesExist && (this.allServices["SellingTariffGeneralSurcharge"] || this.allServices["SellingTariffCancellationSurcharge"] || this.allServices["SellingTariffPeakPeriodSurcharge"] || this.allServices["SellingTariffWaitingTimeSurcharge"]);
    },
    isSellingTariffMarkupVisible: function isSellingTariffMarkupVisible() {
      return this.isServicesExist && this.allServices["SellingTariffMarkup"];
    },
    isSellingTariffIncentiveVisible: function isSellingTariffIncentiveVisible() {
      return this.isServicesExist && this.allServices["SellingTariffIncentive"];
    },
    isSellingTariffIncentiveCompanyVisible: function isSellingTariffIncentiveCompanyVisible() {
      return this.isServicesExist && this.allServices["SellingTariffIncentiveCompany"];
    },
    cdn: function cdn() {
      return "https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com";
    }
  },
  data: function data() {
    return {
      logo: "",
      allServices: null,
      rentalLabel: null,
      tariffScheme: {
        setting: "",
        globallyPerClass: false,
        vehicleOverrides: false
      },
      productImage: null,
      userType: null,
      UserType: __WEBPACK_IMPORTED_MODULE_2__models_constants__["p" /* UserType */],
      userRoles: []
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;
              _context.next = 5;
              return _this.$store.dispatch("user/getProfile");

            case 5:
              profile = _context.sent;


              _this.userRoles = profile.roles;

              _this.productImage = _this.$helper.extractSetting(publicSettings, "SidebarLogo", _this.cdn + "/images/logo-icon-text.png");

              _this.setupLogo(publicSettings);
              _this.setupRentalLabel(publicSettings);
              _this.setupTariffScheme(publicSettings);

              _this.allServices = profile.services;
              _this.userType = profile.userType;

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setupLogo: function setupLogo(publicSettings) {
      this.logo = this.$helper.extractSetting(publicSettings, "Logo", "https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com" + "/images/logo-text.png");
    },
    setupRentalLabel: function setupRentalLabel(publicSettings) {
      this.rentalLabel = this.$helper.extractSetting(publicSettings, "RentalLabel", "Hourly");
    },
    setupTariffScheme: function setupTariffScheme(publicSettings) {
      var tariffSchemeSetting = this.$helper.extractSetting(publicSettings, "TariffScheme", "GloballyPerClass");
      // const tariffSchemeSetting = 'GloballyPerClass';

      this.tariffScheme = {
        setting: tariffSchemeSetting,
        globallyPerClass: tariffSchemeSetting === "GloballyPerClass",
        vehicleOverrides: tariffSchemeSetting === "VehicleOverrides"
      };
    }
  }
});

/***/ }),

/***/ 809:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_Disclaimer__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_Privacy__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_Terms__ = __webpack_require__(1096);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    disclaimer: __WEBPACK_IMPORTED_MODULE_2__components_shared_Disclaimer__["a" /* default */],
    privacyPolicy: __WEBPACK_IMPORTED_MODULE_3__components_shared_Privacy__["a" /* default */],
    termsOfUse: __WEBPACK_IMPORTED_MODULE_4__components_shared_Terms__["a" /* default */]
  },
  computed: {
    thisYear: function thisYear() {
      return new Date().getFullYear();
    },
    cdn: function cdn() {
      return "https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com";
    }
  },
  data: function data() {
    return {
      logo: null,
      productUrl: null,
      productTitle: null
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;

              _this.logo = _this.$helper.extractSetting(publicSettings, "MainLogo", _this.cdn + "/images/logo-icon-text.png");
              _this.productUrl = _this.$helper.extractSetting(publicSettings, "ProductUrl", "https://trransfer.com");
              _this.productTitle = _this.$helper.extractSetting(publicSettings, "ProductTitle", "Trransfer").toUpperCase();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    openDisclaimer: function openDisclaimer() {
      $("#disclaimer-modal-input").modal();
    },
    openPrivacyPolicy: function openPrivacyPolicy() {
      $("#policy-modal-input").modal();
    },
    openTermsOfUse: function openTermsOfUse() {
      $("#terms-modal-input").modal();
    }
  }
});

/***/ }),

/***/ 810:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    thisYear: function thisYear() {
      return new Date().getFullYear();
    },
    brands: function brands() {
      return "Trransfer".toUpperCase();
    }
  }
});

/***/ }),

/***/ 811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    thisYear: function thisYear() {
      return new Date().getFullYear();
    },
    brands: function brands() {
      return "Trransfer".toUpperCase();
    }
  }
});

/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    thisYear: function thisYear() {
      return new Date().getFullYear();
    },
    brands: function brands() {
      return "Trransfer".toUpperCase();
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/51.745eb9128be64953cc9d.js